import { UserWithEntitlements } from './entitlements.types';

const LEGACY_MIN_MINUTES = 10;

function parseLimits(raw: unknown): Record<string, unknown> | null {
  if (!raw) {
    return null;
  }
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw) as Record<string, unknown>;
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch {
      return null;
    }
  }
  return typeof raw === 'object' ? (raw as Record<string, unknown>) : null;
}

/** Read plan minimum from users/me meta.limits (source of truth when present). */
export function readScreenshotIntervalMinFromUser(
  user: UserWithEntitlements | null | undefined
): number | null {
  const limits = parseLimits(user?.meta?.limits ?? (user as Record<string, unknown> | undefined)?.['limits']);
  if (!limits) {
    return null;
  }
  const raw =
    limits['screenshot_interval_min_minutes']
    ?? limits['screenshotIntervalMinMinutes'];
  if (raw === null || raw === undefined || Number.isNaN(Number(raw))) {
    return null;
  }
  const minutes = Math.floor(Number(raw));
  return minutes >= 1 ? minutes : null;
}

/**
 * Effective UI floor:
 * - backend limit wins when present (e.g. Basic = 10)
 * - otherwise Professional short-interval entitlement allows 1
 */
export function resolveScreenshotIntervalFloorMinutes(
  user: UserWithEntitlements | null | undefined,
  hasShortScreenshotInterval: boolean
): number {
  const fromBackend = readScreenshotIntervalMinFromUser(user);
  if (fromBackend != null) {
    return fromBackend;
  }
  if (hasShortScreenshotInterval) {
    return 1;
  }
  return LEGACY_MIN_MINUTES;
}
